/**
 * Created by luka on 01.03.2018.
 */
export const LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL';
export const UPDATE_TO_SAME_LEVEL = "UPDATE_TO_SAME_LEVEL";
export const LEVEL_UPDATED = "LEVEL_UPDATED";
export const LEVEL_SET = "LEVEL_SET";
export const DECLINE_SUCCESSFUL = "DECLINE_SUCCESSFUL";
export const PAYOUT_REQUEST_SUCCESSFUL = "PAYOUT_REQUEST_SUCCESSFUL";
export const USER_INTERRUPT_SUCCESSFUL = "USER_INTERRUPT_SUCCESSFUL";
export const INTERRUPT_NOT_ALLOWED = "INTERRUPT_NOT_ALLOWED";
export const INTERRUPT_NOT_ALLOWED_CHEATED = "INTERRUPT_NOT_ALLOWED_CHEATED";
export const NO_INTERRUPT_WHILE_INTERRUPTED = "NO_INTERRUPT_WHILE_INTERRUPTED";
export const PAYOUT_REQUEST_NOT_ALLOWED = "PAYOUT_REQUEST_NOT_ALLOWED";
export const INCOMPLETE_DATA = "INCOMPLETE_DATA";
export const RETRY_SUCCESSFUL = "RETRY_SUCCESSFUL";
export const LEVEL_NOT_SET = "LEVEL_NOT_SET";
export const USER_NOT_FOUND = "USER_NOT_FOUND";
export const INVALID_TOKEN = "INVALID_TOKEN";
export const ACCOUNT_DISABLED = "ACCOUNT_DISABLED";
export const DAY_SUBMITTED = "DAY_SUBMITTED";
export const REORDER_SUCCESSFUL = "REORDER_SUCCESSFUL";


export const  EXTEND_REQUEST_SUCCESSFUL = "EXTEND_REQUEST_SUCCESSFUL";


// WEBPACK FOOTER //
// ./src/utils/constants.js